import React, { useCallback, useEffect, useState } from "react";
import Table from "../../../Table";
import Modal from "../../../modal";
import { FaAngleDown } from "react-icons/fa6";
import { Dropdown } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  GetSale,
  UpdateSaleTransaction,
} from "../../../../redux/Transaction/action";
import dayjs from "dayjs";
import useInfiniteScroll from "../../../Hooks/useInfiniteScroll";
import NoData from "../../../noData";
import { generatePopup } from "../../../../utility/popup";

const SaleTable = ({ filter, hasMoreData, setFilter, searchValue }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState(false);
  const [salesData, setSalesData] = useState([]);
  const [selectedSale, setSelectedSale] = useState(null); // State for selected sale

  const saleData = useSelector((state) => state?.Sale?.saleData?.data);

  const openModal = (sale) => {
    setSelectedSale(sale);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    setSelectedSale(null); // Reset selected sale
  };

  const handleApproval = () => {
    // Implement your approval logic here with selectedSale data
    let obj = {
      date: dayjs(selectedSale?.date).format("DD/MM/YYYY").toString(),
      nonvatsale: selectedSale?.nonvatsale,
      vatsale: selectedSale?.vatsale,
      vatamount: selectedSale?.vatamount,
      cashamount: selectedSale?.cashamount,
      bankamount: selectedSale?.bankamount,
      lottery: selectedSale?.lottery,
      payzone: selectedSale?.payzone,
      oyester: selectedSale?.oyester,
      status: selectedSale?.status ? false : true,
    };
    dispatch(
      UpdateSaleTransaction({
        id: selectedSale?._id,
        data: obj,
      })
    ).then((res) => {
      if (res?.status === 200) {
        dispatch(
          GetSale({
            page: filter?.page,
            limit: filter?.limit,
            storeName: searchValue,
          })
        );
      } else if (res?.data?.status === 401) {
        navigate("/");
      } else if (res?.data?.status === 400) {
        generatePopup("error", res?.data?.message);
      }
    });
    closeModal();
  };

  const tableHeading = {
    no: <div className="ml-2 text-center">No.</div>,
    store: <div className="px-2 text-left">Store</div>,
    date: <div className="text-center">Date</div>,
    nonvatsale: <div className="text-center">Non VAT SALE</div>,
    vatSale: <div className="text-center ">VAT Sale</div>,
    vatAmount: <div className="text-center">VAT Amount</div>,
    cashAmount: <div className="text-center ">Cash Amount</div>,
    bankAmount: <div className="text-center">Bank Amount</div>,
    total: <div className="text-center ">Total</div>,
    status: <div className="mr-2 text-center  ">Status</div>,
  };

  const headData = Object.values(tableHeading);

  const fetchMoreData = useCallback(() => {
    if (hasMoreData) {
      setFilter((prev) => ({ ...prev, limit: prev.limit + 10 }));
    }
  }, [hasMoreData]);

  const lastElementRef = useInfiniteScroll(fetchMoreData);

  useEffect(() => {
    setSalesData(saleData);
  }, [saleData]);

  const data = salesData?.map((e, index) => {
    const status = e?.status ? "Approved" : "Pending";
    const items = [
      {
        label: e?.status ? "Pending" : "Approve",
        key: e?.status ? "pending" : "approve",
        icon: <img src="/images/checkCircle.svg" alt="" />,
      },
    ];
    const menuProps = {
      items,
      onClick: () => openModal(e),
    };

    return {
      no: <div className="ml-2 text-center ">{index + 1}</div>,
      store: (
        <div className="px-2 text-left ">
          {e?.createdBy?.user?.name || e?.createdBy?.store?.name}
        </div>
      ),
      date: (
        <div className="text-center">{dayjs(e?.date).format("DD/MM/YYYY")}</div>
      ),
      nonvatsale: <div className="text-center ">{e?.nonvatsale}</div>,
      vatSale: <div className="text-center ">{e?.vatsale}</div>,
      vatAmount: <div className="text-center ">{e?.vatamount}</div>,
      cashAmount: <div className="text-center ">{e?.cashamount}</div>,
      bankAmount: <div className="text-center ">{e?.bankamount}</div>,
      total: <div className="text-center">{e?.total}</div>,
      status: (
        <div className="flex items-center justify-center px-2">
          <Dropdown placement="bottomRight" menu={menuProps}>
            <div
              className={`${
                e?.status
                  ? "text-green bg-green/10"
                  : "text-textyellow bg-bgyellow"
              } w-[90px] text-xs font-normal rounded px-1.5 py-2 flex justify-center items-center gap-1 cursor-pointer`}
            >
              {status}
              <FaAngleDown className="duration-500" />
            </div>
          </Dropdown>
        </div>
      ),
    };
  });

  return (
    <>
      {data?.length > 0 ? (
        <Table
          tableHeading={headData}
          tableData={data}
          rowClass={"text-center"}
          lastElementRef={lastElementRef}
        />
      ) : (
        <NoData />
      )}
      <Modal
        modalWidth="w-1/3"
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        openModal={openModal}
        closeModal={closeModal}
        imgSrc="/images/approval.svg"
        title="Approval"
        btn1="No I Don’t"
        btn2="Yes I Do"
        btnClass={"justify-end"}
        modalContent={
          <p className="text-lg font-medium">
            Would you like to {selectedSale?.status ? "Pending" : "approve"}{" "}
            this store?
          </p>
        }
        handleBtn2={handleApproval}
      />
    </>
  );
};

export default SaleTable;
